import { useItemOutOfStockDateLang } from './useItemOutOfStockDateLang';

export function useItemOutOfStockDate() {
  const lang = useItemOutOfStockDateLang();
  return {
    lang,
  };
}
